import axios from "axios";
import { StatusCodes } from "http-status-codes";
// import { keyDeErrorApi, keyDeErrorLogin } from "../../_comun/reductores/Constantes";

import * as Error from "../isp._comun/servicios/Errores";
import ServicioAPI from "../isp._comun/servicios/ServicioAPI";

export default class ServicioRegistroDeItem extends ServicioAPI {
    
    async hacerRequerimientoAxios(dataItem) {
        const baseUrl = process.env.REACT_APP_API_SERVER + "/items";
        const respAxios = await axios({
            method: "post",
            url: baseUrl,
            data: dataItem,
            headers: {
                "Content-Type": "application/json",
                // "Access-Control-Allow-Origin": "*",
                // "Content-Type": "application/x-www-form-urlencoded",
            },
            withCredentials: true,
            signal: this.controller.signal
        });
        return respAxios;
    }

    getDataDeRespuestaAxiosExitosa(respAxiosExito) {
        const respuestaApi = respAxiosExito.data;
        let dataDeCreacionDeCliente;
        try {
            //parsear respuestaApi de tal manera que la data tenga el formato de exito correcto
            //Si hay error en parseo:
            // throw new ErrorDeApp.ErrorFormatoDeCom();
            dataDeCreacionDeCliente = respuestaApi.data;
        } catch (error) {
            throw new Error.ErrorDeProtocoloDelServidor();
        }
        return dataDeCreacionDeCliente;
    }

    lanzarErrorDeRespuestaAxiosErroneaDelComando(errorAxios) {
        const respAxiosError = errorAxios.request;

        if (respAxiosError.status === StatusCodes.UNPROCESSABLE_ENTITY) {
            //Se parsea respuestaApiComoString
            const respuestaApiComoString = respAxiosError.response;

            let respuestaApi = null;
            try {
                respuestaApi = JSON.parse(respuestaApiComoString);
                const errores = respuestaApi.data.erroresEnItem;
                if (errores.length < 1 || errores.length > 20) {
                    throw new Error("Error Parsing Login");
                }
                /* let usuNoValido=false, otros = 0;
                respuestaApi.data.erroresEnCliente.forEach((e) => {
                    if (e.key === keyDeErrorLogin.usuarioNoVal) {
                        usuNoValido=true;
                    }
                    if (e.key === keyDeErrorLogin.nombreVacio) {
                        otros++;
                    }
                    if (e.key === keyDeErrorLogin.contraVacia) {
                        otros++;
                    }
                });
                if(usuNoValido && otros>0) throw new Error("Error Parsing Login");
                if(!usuNoValido && otros===0) throw new Error("Error Parsing Login"); */
            } catch (error) {
                throw new Error.ErrorDeProtocoloDelServidor();
            }

            throw new Error.ListaDeErroresDelDominio({
                errores: respuestaApi.data.erroresEnItem,
            });
        }
    }
}
